import { render, staticRenderFns } from "./AddSeriesQuestionGptResponse.vue?vue&type=template&id=72376936&"
import script from "./AddSeriesQuestionGptResponse.vue?vue&type=script&lang=js&"
export * from "./AddSeriesQuestionGptResponse.vue?vue&type=script&lang=js&"
import style0 from "./AddSeriesQuestionGptResponse.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports